import React, { useState } from 'react';
import {
    Form,
    Input,
    Container,
} from "reactstrap";
import { userUpdateApi } from "../../doctorapi";
import { toast } from "react-toastify";
import { FullWrap, FormWrap, Heading, LoginButton } from "../Userlogin/styles";
import { useHistory } from "react-router-dom"

const UpdatePassword = ({ location }) => {
    const [updateValues, setUpdateValues] = useState({
        password: "",
        confirm_password: ""
    })

    const search = location && location.search.substring(1);
    const params = Object.fromEntries(new URLSearchParams(search));

    const UserUpdatePassword = (e) => {
        setUpdateValues({ ...updateValues, [e.target.name]: e.target.value })
    }
    const disable = updateValues.password !== updateValues.confirm_password || !updateValues.password || !updateValues.confirm_password
    let history = useHistory()
    const handlesubmit = () => {
        const data = {
            password: updateValues.password,
            id: params.id,
        }
        userUpdateApi(data).then(response => {
            if (response.data.statusCode === 200) {
                toast.success("Password reset successfully")
                setUpdateValues({
                    password: "",
                    confirm_password: ""
                });
                history.push('/login')
            } else {
                toast.error("something went wrong")
            }
        }).catch(error => {
            toast.error(error || "something went wrong")
        })
    }
    return (
        <FullWrap>
            <Container>
                <FormWrap>
                    <Form
                        action=""
                        className="form"
                        method=""
                        autoComplete="off">
                        <Heading>Update Password</Heading>
                        <Input
                            placeholder="Enter your password"
                            type="password"
                            name="password"
                            value={updateValues.password}
                            onChange={(e) => UserUpdatePassword(e)}
                        />
                        <Input
                            placeholder="Enter your confirm password"
                            type="password"
                            name="confirm_password"
                            value={updateValues.confirm_password}
                            onChange={(e) => UserUpdatePassword(e)}
                        />
                        <LoginButton
                            block
                            onClick={(e) => handlesubmit(e)}
                            disabled={disable}
                        >
                            Submit
                        </LoginButton>
                    </Form>
                </FormWrap>
            </Container>
        </FullWrap>
    );
};

export default UpdatePassword;


// WEBPACK FOOTER //
// ./src/component/UserUpdatePassword/index.js